import type { SVGProps } from 'react';
const DawnFlagGH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-GH_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-GH_svg__a)">
      <path fill="#E71F37" d="M0 5.333h22V0H0z" />
      <path fill="#118B56" d="M0 16h22v-5.333H0z" />
      <path fill="#FDD64C" d="M0 10.667h22V5.333H0z" />
      <path
        fill="#262626"
        d="m11 9.29-1.54 1.134.585-1.841-1.536-1.14 1.9-.004L11 5.6l.591 1.84 1.9.003-1.535 1.14.584 1.841z"
      />
    </g>
  </svg>
);
export default DawnFlagGH;
